/** Every permission key the app checks, one row per module; `screens.test.ts` keeps it equal to the database's keys. */
export const SCREENS = [
    {
        module: 'company',
        area: 'Foundations',
        basic: ['view'],
        actions: { editDetails: 'Edit details' },
    },
    {
        module: 'settings',
        area: 'Foundations',
        basic: ['view'],
        actions: { editShippingTerms: 'Ship terms', editFobPoint: 'FOB points' },
    },
    { module: 'department', area: 'Foundations', basic: ['view', 'edit'] },
    { module: 'userGroup', area: 'Foundations', basic: ['view', 'edit'] },
    { module: 'user', area: 'Foundations', basic: ['view', 'edit'] },
    {
        module: 'part',
        area: 'Foundations',
        basic: ['view', 'edit'],
        actions: { accounting: 'Accounts tab' },
    },
    { module: 'locationGroup', area: 'Foundations', basic: ['view', 'edit'] },
    { module: 'location', area: 'Foundations', basic: ['view', 'edit'] },
    {
        module: 'customer',
        area: 'Foundations',
        basic: ['view', 'edit'],
        actions: { accounting: 'Check balance', overrideHold: 'Override hold' },
    },
    { module: 'vendor', area: 'Foundations', basic: ['view', 'edit'] },
    { module: 'brand', area: 'Foundations', basic: ['view', 'edit'] },
    {
        module: 'product',
        area: 'Foundations',
        basic: ['view', 'edit'],
        actions: { pricing: 'Pricing', tree: 'Product tree' },
    },
    { module: 'carrier', area: 'Foundations', basic: ['view', 'edit'] },
    { module: 'paymentTerms', area: 'Foundations', basic: ['view'] },
    { module: 'shipping', area: 'Foundations', basic: ['view'] },
    { module: 'uom', area: 'Foundations', basic: ['view'] },
    { module: 'currency', area: 'Foundations', basic: ['view'] },
    { module: 'taxRate', area: 'Foundations', basic: ['view'] },
    { module: 'contact', area: 'Foundations', basic: ['view'] },
    { module: 'customField', area: 'Foundations', basic: ['view'] },
    { module: 'importsExport', area: 'Foundations', basic: [], actions: { export: 'Export lists' } },
    {
        module: 'salesOrder',
        area: 'Sales',
        basic: ['view', 'edit'],
        actions: {
            issue: 'Issue',
            approve: 'Approve',
            actions: 'Ship & complete',
            voidcancel: 'Void / cancel',
            revertStatus: 'Move back',
            payment: 'Take payment',
            priceoverride: 'Edit price',
            overrideDiscountAmount: 'Override discount',
            overrideFlatTaxAmount: 'Override flat tax',
            editPaymentTerms: 'Edit payment terms',
            editSalesperson: 'Edit salesperson',
            markup: 'Markup',
            cost: 'See cost',
        },
    },
    { module: 'payment', area: 'Sales', basic: ['view', 'edit', 'delete'] },
    { module: 'accountsReceivable', area: 'Sales', basic: ['view'] },
    { module: 'invoice', area: 'Sales', basic: ['view'], actions: { void: 'Void' } },
    {
        module: 'promotion',
        area: 'Sales',
        basic: ['view', 'edit', 'delete'],
        actions: { approve: 'Approve' },
    },
    {
        module: 'pricingEngine',
        area: 'Sales',
        basic: ['view', 'edit', 'delete'],
        actions: { lock: 'Lock' },
    },
    { module: 'pricingRule', area: 'Sales', basic: ['view', 'edit', 'delete'] },
    { module: 'territory', area: 'Sales', basic: ['view'] },
    { module: 'salesTarget', area: 'Sales', basic: ['view'] },
    { module: 'commission', area: 'Sales', basic: ['view'] },
    {
        module: 'event',
        area: 'Events',
        basic: ['view', 'edit'],
        actions: { approve: 'Approve', template: 'Templates' },
    },
    { module: 'eventStaffing', area: 'Events', basic: ['view'] },
    { module: 'calendar', area: 'Events', basic: ['view'] },
    { module: 'purchaseOrder', area: 'Sourcing', basic: ['view', 'edit'] },
    { module: 'rma', area: 'Sourcing', basic: ['view'] },
    {
        module: 'receiving',
        area: 'Operations',
        basic: ['view'],
        actions: { receive: 'Receive', allowOverReceipt: 'Over-receive' },
    },
    {
        module: 'picking',
        area: 'Operations',
        basic: ['view', 'edit'],
        actions: { start: 'Start', commit: 'Commit', finish: 'Finish' },
    },
    {
        module: 'inventory',
        area: 'Operations',
        basic: ['view'],
        actions: {
            add: 'Add',
            addLot: 'Add lot',
            move: 'Move',
            cycle: 'Count',
            scrap: 'Scrap',
            explainVariance: 'Explain variance',
            showpartcost: 'See cost',
        },
    },
    {
        module: 'transferOrder',
        area: 'Operations',
        basic: ['view', 'edit', 'delete'],
        actions: { issue: 'Issue' },
    },
    {
        module: 'manufactureOrder',
        area: 'Operations',
        basic: ['view', 'edit'],
        actions: {
            issue: 'Issue',
            woEdit: 'Edit work orders',
            woStart: 'Start WO',
            woFinish: 'Finish WO',
            woVoid: 'Void WO',
            payrollView: 'See labor pay',
        },
    },
    { module: 'workOrder', area: 'Operations', basic: ['view'] },
    { module: 'bom', area: 'Operations', basic: ['view', 'edit'] },
    { module: 'strain', area: 'Operations', basic: ['view'] },
    { module: 'cannabisCompliance', area: 'Operations', basic: ['view'] },
    { module: 'leafLinkIntegration', area: 'Integrations', basic: ['view', 'edit'] },
    { module: 'accountingIntegration', area: 'Integrations', basic: ['view', 'edit'] },
    { module: 'integrations', area: 'Integrations', basic: ['view'] },
    { module: 'auditLog', area: 'System', basic: ['view'], actions: { payload: 'Raw payload' } },
    { module: 'reports', area: 'System', basic: ['view'] },
    {
        module: 'monitor',
        area: 'System',
        basic: ['view'],
        actions: { legacyFields: 'Legacy fields' },
    },
    { module: 'account', area: 'Other data', basic: ['view'] },
    { module: 'accountOnboarding', area: 'Other data', basic: ['view'] },
    { module: 'accountsPayable', area: 'Other data', basic: ['view'] },
    { module: 'biReport', area: 'Other data', basic: ['view'] },
    { module: 'class', area: 'Other data', basic: ['view'] },
    { module: 'data', area: 'Other data', basic: ['view'] },
    { module: 'deliveryLogistics', area: 'Other data', basic: ['view'] },
    { module: 'dimeCheckout', area: 'Other data', basic: ['view'] },
    { module: 'expense', area: 'Other data', basic: ['view'] },
    { module: 'media', area: 'Other data', basic: ['view'] },
    { module: 'menu', area: 'Other data', basic: ['view'] },
    { module: 'paymentGateway', area: 'Other data', basic: ['view'] },
    { module: 'project', area: 'Other data', basic: ['view'] },
    { module: 'qrCode', area: 'Other data', basic: ['view'] },
    { module: 'schedule', area: 'Other data', basic: ['view'] },
    {
        module: 'task',
        area: 'Other data',
        basic: ['view'],
        actions: { transcription: 'Transcripts' },
    },
];
//# sourceMappingURL=screens.js.map